import { render } from "./LegacyOrderSummaryList.vue?vue&type=template&id=4b4df2dc"
import script from "./LegacyOrderSummaryList.vue?vue&type=script&lang=js"
export * from "./LegacyOrderSummaryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__